import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const steps = [
  {
    number: '01',
    title: 'Fiyat Teklifi Al',
    description: 'Online formumuzdan cihaz bilgilerinizi girerek ücretsiz fiyat teklifi alın.',
  },
  {
    number: '02',
    title: 'Randevu Oluştur',
    description: 'Size uygun tarih ve saati seçerek randevunuzu oluşturun.',
  },
  {
    number: '03',
    title: 'Cihazı Teslim Et',
    description: 'Cihazınızı mağazamıza teslim edin veya kargo ile gönderin.',
  },
  {
    number: '04',
    title: 'Onarımı Takip Et',
    description: 'Onarım sürecini anlık olarak takip edin ve bilgilendirilerin.',
  },
  {
    number: '05',
    title: 'Cihazı Teslim Al',
    description: 'Onarımı tamamlanan cihazınızı garantili olarak teslim alın.',
  },
];

export const HowItWorks = () => {
  return (
    <section className="py-16 lg:py-24 bg-foreground text-background overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <motion.span
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="inline-block text-sm font-medium text-primary uppercase tracking-wider mb-3"
            >
              Nasıl Çalışır?
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-3xl sm:text-4xl lg:text-5xl font-bold font-display mb-6"
            >
              5 Adımda Kolay Servis
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="text-lg text-background/70 mb-8"
            >
              Cihazınızın onarımı için hızlı ve kolay adımları takip edin. 
              Profesyonel ekibimiz en kısa sürede cihazınızı yenilemiş gibi teslim eder.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="flex flex-wrap gap-4"
            >
              <Button
                asChild
                size="lg"
                className="bg-primary hover:bg-primary-light"
              >
                <Link to="/servis">
                  Şimdi Başla
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-background/30 text-background hover:bg-background/10 bg-transparent"
              >
                <Link to="/destek">Yardım Al</Link>
              </Button>
            </motion.div>
          </div>

          {/* Right Steps */}
          <div className="space-y-6">
            {steps.map((step, index) => (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex gap-4 group"
              >
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-sm group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                    {step.number}
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold font-display mb-1 group-hover:text-primary transition-colors">
                    {step.title}
                  </h3>
                  <p className="text-background/60">{step.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
